import { getSensorsList, getSensorsListRejected, getSensorsListResolved, resetSensorList, } from '@innovyze/stylovyze/lib/actions/sensor.actions';
import { createReducer } from '@reduxjs/toolkit';
import { STATUS_ENUM } from '../types';
export const initialState = {
    initialized: false,
    status: STATUS_ENUM.IDLE,
    sensors: [],
};
const reducer = {
    [resetSensorList.toString()]: () => initialState,
    [getSensorsList.toString()]: state => ({
        ...state,
        status: STATUS_ENUM.PENDING,
    }),
    [getSensorsListResolved.toString()]: (state, action) => ({
        ...state,
        sensors: action?.payload || [],
        status: STATUS_ENUM.SUCCESS,
        initialized: true,
    }),
    [getSensorsListRejected.toString()]: state => ({
        ...state,
        initialized: true,
        status: STATUS_ENUM.ERROR,
    }),
};
export default createReducer(initialState, reducer);
